/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
export const Server = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "css">
>((props, ref) => (
  <svg
    id="ab6f3a82-a3cc-493a-ade9-04ddbc97f389"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <defs>
      <style>
        {
          ".aad116b4-7f03-4c14-818a-3c84cc33d1e0{fill:#fff}.eaa2e809-8d39-4cf7-919c-a293023b975a{stroke:#3f20ba;stroke-miterlimit:10;stroke-width:.5px;fill:none}.f3b687cc-3929-4243-a7dc-5425ddf6a478{fill:#3f20ba}"
        }
      </style>
    </defs>
    <path
      d="M19.16 7.58l-5.66 3.26a3 3 0 0 1-3 0L4.84 7.58a1 1 0 0 1-.5-.87v3.5a1 1 0 0 0 .5.87l2.83 1.63 2.83 1.63a2.95 2.95 0 0 0 3 0l2.83-1.63 2.83-1.63a1 1 0 0 0 .5-.87v-3.5a1 1 0 0 1-.5.87z"
      className="aad116b4-7f03-4c14-818a-3c84cc33d1e0"
    />
    <path
      d="M19.16 11.08l-5.66 3.26a3 3 0 0 1-3 0l-5.66-3.26a1 1 0 0 1-.5-.87v3.5a1 1 0 0 0 .5.87l2.83 1.63 2.83 1.63a2.95 2.95 0 0 0 3 0l2.83-1.63 2.83-1.63a1 1 0 0 0 .5-.87v-3.5a1 1 0 0 1-.5.87z"
      className="aad116b4-7f03-4c14-818a-3c84cc33d1e0"
    />
    <path
      d="M19.16 14.58l-5.66 3.26a3 3 0 0 1-3 0l-5.66-3.26a1 1 0 0 1-.5-.87v3.5a1 1 0 0 0 .5.87l2.83 1.63 2.83 1.63a2.95 2.95 0 0 0 3 0l2.83-1.63 2.83-1.63a1 1 0 0 0 .5-.87v-3.5a1 1 0 0 1-.5.87z"
      className="aad116b4-7f03-4c14-818a-3c84cc33d1e0"
    />
    <path
      fill="#d9cfff"
      stroke="#3f20ba"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M19.16 7.58l-5.66 3.26a3 3 0 0 1-3 0L4.84 7.58a1 1 0 0 1 0-1.74l5.66-3.26a3 3 0 0 1 3 0l5.66 3.26a1 1 0 0 1 0 1.74z"
    />
    <path
      d="M19.16 7.58l-5.66 3.26a3 3 0 0 1-3 0L4.84 7.58a1 1 0 0 1-.5-.87v3.5a1 1 0 0 0 .5.87l2.83 1.63 2.83 1.63a2.95 2.95 0 0 0 3 0l2.83-1.63 2.83-1.63a1 1 0 0 0 .5-.87v-3.5a1 1 0 0 1-.5.87z"
      className="eaa2e809-8d39-4cf7-919c-a293023b975a"
    />
    <path
      d="M19.16 11.08l-5.66 3.26a3 3 0 0 1-3 0l-5.66-3.26a1 1 0 0 1-.5-.87v3.5a1 1 0 0 0 .5.87l2.83 1.63 2.83 1.63a2.95 2.95 0 0 0 3 0l2.83-1.63 2.83-1.63a1 1 0 0 0 .5-.87v-3.5a1 1 0 0 1-.5.87z"
      className="eaa2e809-8d39-4cf7-919c-a293023b975a"
    />
    <path
      d="M19.16 14.58l-5.66 3.26a3 3 0 0 1-3 0l-5.66-3.26a1 1 0 0 1-.5-.87v3.5a1 1 0 0 0 .5.87l2.83 1.63 2.83 1.63a2.95 2.95 0 0 0 3 0l2.83-1.63 2.83-1.63a1 1 0 0 0 .5-.87v-3.5a1 1 0 0 1-.5.87z"
      className="eaa2e809-8d39-4cf7-919c-a293023b975a"
    />
    <path
      d="M5.02 18.33l.25-8.64.25 8.64h-.5zM5.89 18.83l.25-8.64.25 8.64h-.5zM6.75 19.33L7 10.69l.25 8.64h-.5zM7.62 19.83l.25-8.64.25 8.64h-.5zM8.49 20.33l.25-8.64.25 8.64h-.5zM9.35 20.83l.25-8.64.25 8.64h-.5zM10.22 21.33l.25-8.64.25 8.64h-.5zM11.09 21.83l.25-8.64.25 8.64h-.5z"
      className="f3b687cc-3929-4243-a7dc-5425ddf6a478"
    />
    <ellipse
      cx={18.35}
      cy={9.79}
      className="f3b687cc-3929-4243-a7dc-5425ddf6a478"
      rx={0.61}
      ry={0.35}
      transform="rotate(-60 18.346 9.784)"
    />
    <ellipse
      cx={18.35}
      cy={13.29}
      className="f3b687cc-3929-4243-a7dc-5425ddf6a478"
      rx={0.61}
      ry={0.35}
      transform="rotate(-60 18.342 13.291)"
    />
    <ellipse
      cx={18.35}
      cy={16.79}
      className="f3b687cc-3929-4243-a7dc-5425ddf6a478"
      rx={0.61}
      ry={0.35}
      transform="rotate(-60 18.342 16.79)"
    />
    <ellipse
      cx={16.83}
      cy={10.66}
      className="f3b687cc-3929-4243-a7dc-5425ddf6a478"
      rx={0.61}
      ry={0.35}
      transform="rotate(-60 16.833 10.665)"
    />
    <ellipse
      cx={16.83}
      cy={14.16}
      className="f3b687cc-3929-4243-a7dc-5425ddf6a478"
      rx={0.61}
      ry={0.35}
      transform="rotate(-60 16.833 14.164)"
    />
    <ellipse
      cx={16.83}
      cy={17.66}
      className="f3b687cc-3929-4243-a7dc-5425ddf6a478"
      rx={0.61}
      ry={0.35}
      transform="rotate(-60 16.834 17.663)"
    />
    <ellipse
      cx={15.32}
      cy={11.54}
      className="f3b687cc-3929-4243-a7dc-5425ddf6a478"
      rx={0.61}
      ry={0.35}
      transform="rotate(-60 15.31 11.541)"
    />
    <ellipse
      cx={15.32}
      cy={15.04}
      className="f3b687cc-3929-4243-a7dc-5425ddf6a478"
      rx={0.61}
      ry={0.35}
      transform="rotate(-60 15.311 15.04)"
    />
    <ellipse
      cx={15.32}
      cy={18.54}
      className="f3b687cc-3929-4243-a7dc-5425ddf6a478"
      rx={0.61}
      ry={0.35}
      transform="rotate(-60 15.312 18.54)"
    />
  </svg>
));
